import { render, staticRenderFns } from "./ShenPiYongZhang.vue?vue&type=template&id=5adb0194&scoped=true&"
import script from "./ShenPiYongZhang.vue?vue&type=script&lang=js&"
export * from "./ShenPiYongZhang.vue?vue&type=script&lang=js&"
import style0 from "./ShenPiYongZhang.vue?vue&type=style&index=0&id=5adb0194&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adb0194",
  null
  
)

export default component.exports